import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isStateSameOrParent } from '@Utils/router-state';
import { NavGroup } from '@els/els-react--nav-group';
import NavMenuItems from './NavMenuItems';

import './GeneralMenuItems.scss';

function GeneralMenuItemsComponent({ activeResults, isAnonymousUser, isRMCLicense, history, goToResults, onItemClick }) {
  const [activeNavItem, setActiveNavItem] = useState(null);

  useEffect(() => {
    const pathName = history.location.pathname;
    const activeItem = Object.values(NavMenuItems).find(
      (item) => isStateSameOrParent(pathName, item.path) || (item.id === NavMenuItems.results.id && pathName.indexOf('/results/') >= 0)
    );
    setActiveNavItem(activeItem ? activeItem.id : null);
  }, [history.location.pathname]);

  const handleGoToResults = () => {
    if (activeResults) {
      if (typeof onItemClick === 'function') {
        onItemClick();
      }
      goToResults();
    }
  };

  const getLinks = () => {
    const baseLinks = [
      NavMenuItems.quickSearch,
      NavMenuItems.queryBuilder,
      NavMenuItems.results,
      ...(!isRMCLicense ? [NavMenuItems.retrosynthesis] : []),
      NavMenuItems.history,
      ...(isAnonymousUser ? [] : [NavMenuItems.alerts]),
    ];

    return baseLinks.map((item) => {
      const linkProps = {
        id: item.id,
        children: item.label,
        href: item.path,
        className: item?.className,
        onClick: () => {
          if (typeof onItemClick === 'function') {
            onItemClick();
          }
          if (item.id === NavMenuItems.results.id) {
            handleGoToResults();
          }
        },
        routerComponent: Link,
        routerHrefAttribute: 'to',
      };

      if (item.id === NavMenuItems.results.id && !activeResults) {
        linkProps.className = classNames(linkProps.className, 'c-els-link--disabled');
      }

      return linkProps;
    });
  };

  return (
    <NavGroup
      title="Main"
      linkElementData={getLinks()}
      activeId={activeNavItem}
      activeIsLink
      aria-current={activeNavItem}
      id="main-site-navigation"
    />
  );
}

GeneralMenuItemsComponent.propTypes = {
  goToResults: PropTypes.func.isRequired,
  isRMCLicense: PropTypes.bool,
  activeResults: PropTypes.bool,
  isAnonymousUser: PropTypes.bool,
  history: PropTypes.object,
  onItemClick: PropTypes.func,
};

const GeneralMenuItems = withRouter(GeneralMenuItemsComponent);
export default GeneralMenuItems;
